// extracted by mini-css-extract-plugin
module.exports = {"name":"H1_name__3jjKy","br":"H1_br__1_xFs"};